import moment from "moment";
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";

export default (context) => {
  const filter = {
    fields: [
      {
        name: "periodId",
        value: { value: "0", label: "Actual" },
        type: "select",
        label: "Periodo",
        opts: {
          style: 'float-label',
          path: "/admPeriod/get?pick=true"
        }
      },
      {
        type: "daterange"
      },
      {
        name: "userId",
        value: "",
        type: "select",
        label: "Alumno",
        rules: 'required',
        opts: {
          style: 'float-label',
          searchOnline: true,
          withImg: true,
          path: () => { 
            return "/admStudent/get?pick=true"
          }
        }
      },
      {
        col: 3,
        name: "resourceId",
        value: "",
        type: "select",
        label: "Profesor",
        rules: 'required',
        opts: {
          style: 'float-label',
          searchOnline: true,
          withImg: true,
          path: () => { return "/admResource/get?pick=true" }
        }
      },
      {
        name: "status",
        value: null,
        type: "select",
        label: "Estado",
        opts: {
          style: 'float-label',
          items: [
            {
              value: 0,
              label: "Separadas"
            },
            {
              value: 1,
              label: "Confirmadas"
            },
            {
              value: 2,
              label: "Completadas"
            },
          ]
        }
      }
    ],
    buttons: [
      {
        label: 'Aplicar filtro',
        onClick: (ctx) => { ctx.btnAction('filter') }
      }
    ]
  }
  return {
    config: {
      resource: "admBooking",
      pageSize: 40,
      list: false
    },

    actions: {
      create: true,
      edit: true,
      delete: false,
      search: true,
      print: true,
      export: true
    },

    filter: context.props.location?.pathname.indexOf('admBookingList') > -1 ? filter : null,

    form: {
      handleSaveChanges : () => {
        const ctx = context
        if (ctx.state.idItemSelected) ctx.edit()
        else {
          ctx.validateForm().then(() => {
            const save = () => {
              let body = {
                slot: ctx.state.form.completed ? moment(ctx.state.form.date2 + ' ' + moment(ctx.state.form.time2).format('HH:mm:ss')).format('YYYYMMDDHHmm') : ctx.state.form.time,
                resourceId: context.resourceId,
                userId: ctx.state.form.userId.value,
                externalId: null,
                notes: ctx.state.form.notes,
                notesCompleted: ctx.state.form.notesCompleted,
                extras: {
                  CodigoPadreFamilia: ctx.state.form.CodigoPadreFamilia.map((e) => {
                    e = { ID: e.value, name: e.label }
                    return e
                  }),
                  Subject: null,
                  trackingId: ctx.state.form.trackingId,
                },
                completed: ctx.state.form.completed
              }

              // console.log(body)
  
              _axios
                .post('booking/book', body)
                .then(r => {
                  NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                  if (r.status >= 0) {
                    context.toggle()
                    context.getData()
                  }
                  context.props.setLoader(false)
                }).catch(e => {
                  context.props.setLoader(false)
                })
            }

            const createSlot = () => {
              let body = {
                date: ctx.state.form.completed ? moment(ctx.state.form.date2 + ' ' + moment(ctx.state.form.time2).format('HH:mm:ss')).format('YYYYMMDDHHmm') : ctx.state.form.time,
                endDate: ctx.state.form.completed ? moment(ctx.state.form.date2 + ' ' + moment(ctx.state.form.time2).format('HH:mm:ss')).add(20, 'minutes').format('YYYYMMDDHHmm') : null
              }
              _axios
              .post('/booking/slots/' + context.resourceId , body)
              .then(r => {
                  if (r.status >= 0) save()
                  else {
                    context.props.setLoader(false)
                    NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                  }
              }).catch(e => {
                console.log(e)
                context.props.setLoader(false)
              })
            }

            const getResource = () => {
              _axios
              .get('/admResource/active')
              .then(r => {
                if (r.status === 0) {
                  let resource = r.data.find(e => e.owner === context.props.userAdmin.ID)
                  if (resource) {
                    context.resourceId = resource.ID
                    createSlot()
                  }
                  else NotificationManager.error('Antes de registrar una cita debe de registrar al profesor como un recurso.', 'Error', 5000, null, null, 'outline')
                } else {
                  NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
                  context.props.setLoader(false)
                }
              }).catch(e => {
                console.log(e)
                context.props.setLoader(false)
              })
            }

            context.props.setLoader(true)
            ctx.state.form.completed ? getResource() : ctx.state.form.exception ? createSlot() : save()
          })
          .catch(e => { /* console.log(e) */ }) 
        }
      },
      fields: [
        {
          col: 12,
          name: "completed",
          type: "switch",
          label: "CITA YA FUE REALIZADA",
          renderIf: () => { return !context.state.idItemSelected }
        },
        {
          col: 4,
          name: "userId",
          value: window.location.href.indexOf('admTracking') > -1 ? { value: context.props.filterBy.userId, label: context.props.filterBy.userName } : "",
          type: "select",
          label: "Alumno",
          rules: 'required',
          opts: {
            style: 'float-label',
            withImg: true,
            isClearable: false,
            path: () => { return "/teacher/" + context.props.userAdmin.ID + "/students" },
            remap: (r) => {
              return {
                data: {
                  Results: r.data.map(e => {
                    e.ID = e.id
                    e.name = e.last + ', ' + e.name
                    e.img = e.face
                    return e
                  })
                },
                msg: r.msg,
                status: r.status
              }
            },
            setOutput: v => v
          },
          renderIf: () => { return !context.state.idItemSelected },
          disabled: () => { return window.location.href.indexOf('admTracking') > -1 }
        },
        {
          col: 3,
          name: "exception",
          type: "switch",
          label: "Horario de excepción",
          opts: {
            style: 'float-label',
          },
          renderIf: (ctx) => { return !context.state.idItemSelected && !ctx.state.completed}
        },
        {
          col: 4,
          name: "date2",
          type: "date",
          label: "Fecha",
          rules: 'required',
          parent: "completed",
          opts: {
            style: 'float-label',
            maxDate: moment()
          },
          disabled: () => { return context.state.form && context.state.form.userId ? false : true },
          renderIf: (ctx) => { return !context.state.idItemSelected && ctx.state.completed}
        },
        {
          col: 4,
          name: "time2",
          type: "time",
          label: "Hora",
          rules: 'required',
          parent: "date2",
          opts: {
            style: 'float-label',
            timeIntervals: 1,
            minTime: (ctx) => { return moment(ctx.state.date2).format("DD") === moment().date().toString() ? moment().set({hour:0,minute:0,second:0,millisecond:0}) : null },
            maxTime: (ctx) => { return moment(ctx.state.date2).format("DD") === moment().date().toString() ? moment() : null },
          },
          disabled: () => { return context.state.form && context.state.form.userId ? false : true },
          renderIf: (ctx) => { return !context.state.idItemSelected && ctx.state.date2 && ctx.state.completed}
        },
        {
          col: 2,
          name: "date",
          type: "date",
          label: "Fecha",
          rules: 'required',
          parent: "exception",
          opts: {
            style: 'float-label',
            onOpen: (ctxForm, ctxField) => {
              if (context.resourceId) context.resourceId = null
              if (ctxForm.state.exception) ctxField.setState({ highlightDates: undefined, includeDates: undefined })
              // if (!ctxForm.state.exception && ctxField.state.includeDates && ctxForm.state.date) return
              context.props.setLoader(true)
              _axios
              // .get('/booking/resources/' + (window.tenant.isPro ? 118 : 117) + '?from=' + moment().format('YYYY-MM-DDTHH:mm:ss') + '&to='+ moment().add(moment().daysInMonth() - moment().format('D'), 'd').format('YYYY-MM-DDTHH:mm:ss') +'&id=' + context.state.form.userId.value + '&variation=resOwnerByUserId')
              .get('/booking/resources/' + (window.tenant.isPro ? 118 : 117) + '?from=' + moment().format('YYYY-MM-DDTHH:mm:ss') + '&to='+ moment().add(1, 'months').endOf('month').format('YYYY-MM-DDTHH:mm:ss') +'&id=' + context.state.form.userId.value + '&variation=resOwnerByUserId')
              .then(r => {
                if (r.status >= 0) {
                  if (r.data && r.data[0].slots) {
                    if (!ctxForm.state.exception) {
                      let slots = r.data[0].slots.filter(s => s.status !== 1)
                      let dates = slots.map(e => moment(e.date,'YYYYMMDDHHmm'))
                      ctxField.setState({ highlightDates: dates, includeDates: dates }, () => {
                        ctxForm.dates = slots
                        context.resourceId = r.data[0].id
                      })
                    } else context.resourceId = r.data[0].id
                  }
                } else {
                  ctxField.setState({ highlightDates: [], includeDates: [] })
                  /*
                  if (!ctxForm.state.exception) {
                    ctxField.setState({ highlightDates: [], includeDates: [] }, () => {
                      // setTimeout(() => { ctxField.datePickerRef.current.setOpen(false) }, 100)
                    })
                  }
                  */
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                context.props.setLoader(false)
              }).catch(e => {
                context.props.setLoader(false)
              })
            }
          },
          onChange: (ctxForm) => {
            if (!ctxForm.state.exception) return
            _axios
              .get('/agenda/hours?day=' + moment(ctxForm.state.date).format('YYYY-MM-DD') + 'T00:00:00&onDemand=true')
              .then(r => {
                if (r.status >= 0) {
                  if (r.data && r.data.hours) {
                    ctxForm.dates = r.data.hours.split(',')
                    ctxForm.dates = ctxForm.dates.map(e => { return e = moment(ctxForm.state.date).format('YYYYMMDD') + e.replace(':', '') } )
                  }
                } else {
                  ctxForm.dates = []
                  NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
                }
              }).catch(e => {
                console.log(e)
              })
          },
          disabled: () => { return context.state.form && context.state.form.userId ? false : true },
          renderIf: (ctx) => { return !context.state.idItemSelected  && !ctx.state.completed}
        },
        {
          col: 3,
          name: "time",
          value: "",
          type: "select",
          label: "Hora",
          rules: 'required',
          parent: "date",
          opts: {
            style: 'float-label',
            onMenuOpen: (ctxForm, ctxCustomSelect) => {
              let hours = []
              if (ctxForm.state.exception) {
                if (ctxForm.dates) hours = ctxForm.dates.map(e => { return {value: parseInt(e), label: moment(e, 'YYYYMMDDHHmm').format('HH:mm')} })
              } else {
                let date = ctxForm.dates.filter(e => moment(e.date, 'YYYYMMDDHHmm').format('YYYY-MM-DD') === ctxForm.state.date)
                hours = date.map((e) => { return {value: e.date, label: moment(e.date, 'YYYYMMDDHHmm').format('HH:mm') + '- ' + moment(e.endDate, 'YYYYMMDDHHmm').format('HH:mm'), isDisabled: e.status === 1 ? true : false} })
              }
              ctxCustomSelect.setState({ items: hours })
            },
            isClearable: true
          },
          onChange: (ctxForm) => {
            /*
            if (!ctxForm.state.exception || !ctxForm.state.time) return
            _axios
              .post('/booking/slots/' + context.resourceId, {date: ctxForm.state.time})
              .then(r => {
                if (r.status < 0) NotificationManager.error(r.msg, 'Error', 5000, null, null, 'outline')
                else context.canCreateException = true
              }).catch(e => {
                console.log(e)
              })
            */
          },
          disabled: () => { return context.state.form && context.state.form.date ? false : true },
          renderIf: (ctx) => { return !context.state.idItemSelected  && !ctx.state.completed}
        },
        {
          col: 6,
          name: "CodigoPadreFamilia",
          value: "",
          type: "select",
          label: "Participante(s)",
          rules: 'required',
          parent: "userId",
          opts: {
            style: 'float-label',
            isMulti: true,
            path: () => { return "me/family?studentId=" + context.state.form.userId.value + "&externalId=null" },
            remap: (r) => {
              let data = r.data.map(e => {
                e.ID = e.id
                e.name = e.last + ' ' + e.last2 + ', ' + e.name
                return e
              })
              data.splice(0, 0, {ID: context.state.form.userId.value, name: context.state.form.userId.label})
              return {
                data: {
                  Results: data
                },
                msg: r.msg,
                status: r.status
              }
            },
            setOutput: v => v
          },
          disabled: () => {
            let r = true
            if ((context.state.form && context.state.form.time) || (context.state.form && context.state.form.completed)) r = false
            // if (context.state.form && context.state.form.exception && !context.canCreateException) r = true
            return r
          },
          renderIf: () => { return !context.state.idItemSelected }
        },
        {
          col: 6,
          name: "trackingId",
          value: "",
          type: "select",
          label: "Tipo de cita",
          rules: 'required',
          parent: "userId",
          opts: {
            style: 'float-label',
            path: () => { return "tracking/bookingoptions?userId=" + context.state.form.userId.value },
            remap: (r) => {
              r.data.splice(0, 0, {id: -1, name: 'Normal'})
              return {
                data: {
                  Results: r.data.map(e => {
                    e.ID = e.id
                    return e
                  })
                },
                msg: r.msg,
                status: r.status
              }
            },
          },
          disabled: () => { return context.state.form && context.state.form.CodigoPadreFamilia ? false : true },
          renderIf: () => { return !context.state.idItemSelected }
        },
        {
          col: 6,
          name: "userName",
          type: "text",
          label: "Alumno",
          opts: {
            style: 'float-label',
          },
          disabled: true,
          renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 6,
          name: "resourceName",
          type: "text",
          label: "Profesor",
          opts: {
            style: 'float-label',
          },
          disabled: true,
          renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 6,
          name: "dtDate",
          type: "date",
          label: "Fecha",
          opts: {
            style: 'float-label',
            dateFormat: 'YYYY/MM/DD HH:mm'
          },
          disabled: true,
          renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 6,
          name: "status",
          value: 0,
          type: "select",
          label: "Estado",
          rules: 'required',
          opts: {
            style: 'float-label',
            items: [
              {
                value: 0,
                label: "Separadas"
              },
              {
                value: 1,
                label: "Confirmadas"
              },
              {
                value: 2,
                label: "Completadas"
              },
            ]
          },
          disabled: true,
          renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 12,
          name: "notes",
          type: "textarea",
          label: "Motivo",
          rules: 'max:1500',
          opts: {
            style: 'float-label',
            rows: 6
          },
          // renderIf: () => { return context.state.idItemSelected }
        },
        {
          col: 12,
          name: "notesCompleted",
          type: "textarea",
          label: "Acuerdos de cita",
          rules: 'max:1500',
          opts: {
            style: 'float-label',
            rows: 6
          }
        }
      ]
    },

    columns: [
      {
        Header: "Alumno",
        accessor: "userName"
      },
      {
        Header: "Grado/Sección",
        accessor: "sectionTag"
      },
      {
        Header: "Inicio",
        accessor: "dtDate",
        isDate: true
      },
      {
        Header: "Fin",
        accessor: "dtEndDate",
        isDate: true
      },
      {
        Header: "Profesor",
        accessor: "resourceName"
      },
      {
        Header: "Motivo",
        accessor: "notes"
      },
      {
        Header: "Acuerdo de Cita",
        accessor: "notesCompleted"
      }
    ]
  }
}